export type ExcludesFalse = <T>(x: T | false) => x is T
export type Matrix = number[][]

export interface Coordinates {
  x: number
  y: number
}

export function isPrimitive(data: any): data is string | boolean | number {
  return typeof data === 'number' || typeof data === 'boolean' || typeof data === 'string'
}

export const isNumber = (data: any): data is number => typeof data === 'number'
export const isString = (data: any): data is string => typeof data === 'string'
export const isBoolean = (data: any): data is boolean => typeof data === 'boolean'
export const isArray = (obj: any): obj is Array<any> => obj && Array.isArray(obj)
export const isNull = (data: any): data is null => data === null
